import { inject, injectable } from 'inversify';
import ReviewsService from '../../data/service/ReviewsService';

type DismissReviewUseCaseProps = {
  order_pk: number;
  accessToken: string;
};

@injectable()
class DismissReviewUseCase {
  @inject(ReviewsService) private reviewsService!: ReviewsService;

  async execute({ order_pk, accessToken }: DismissReviewUseCaseProps) {
    const response = await this.reviewsService.updateReview({
      order_pk,
      accessToken,
      is_dismissed: true,
    });

    return response.data;
  }
}

export default DismissReviewUseCase;
